import type { AnnouncementAlertBlock } from '@/@types/content';
import Block from '../cms/Block';
import classnames from 'classnames';

const AnnouncementAlertBlock: React.FC<AnnouncementAlertBlock> = ({ contentLink, copy, style }) => {
  const blockStyle = classnames(
    'text-2-fixed mb-3 w-full rounded p-6 text-gray-dark [&_a]:underline',
    style?.toLowerCase() === 'alert' ? 'bg-orange/10 text-orange' : 'bg-gray/10 text-gray'
  );

  return (
    <Block contentLinkID={contentLink?.id} data-component="AnnouncementAlertBlock">
      <div className={blockStyle}>
        {!!copy && <span dangerouslySetInnerHTML={{ __html: copy }} />}
      </div>
    </Block>
  );
};

export default AnnouncementAlertBlock;
